// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__3eyBm","loaderOuter":"PageOverlayLoader_loaderOuter__XHACR"};